<template>
  <div
      :class="['border-radius', isDone ? 'log-task log-task-done' : 'log-task log-task-not-done']"
  >
    <div class="step-content full-width">
      <icon :type="isDone ? 'check' : (task ? 'spinner' : 'times')"
            size="0.9"/>
      <div class="step-name d-inline-block ml-1">{{ $t(label) }}</div>
      <!-- Progress bar -->
      <div v-if="task" class="ml-4 inline-block col-3 dz-progress bg-beige float-right">
        <div :style="{'width': progress + '%'}" class="dz-upload">
          <p>{{ progress }}%</p>
        </div>
      </div>
      <p class="smaller ml-4">{{ duration }}
        <span v-if="duration && totalItems"> | </span><span v-if="totalItems">{{ totalItems }} items</span>
      </p>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon.vue";
import {timeDifferenceFromTwoISOsAsString} from "@/utils";
export default {
  name: "LogEntryProgressBar",
  components: {Icon},
  props: {
    task: {type: Object, default: () => {}},
    step: {type: String, required: true},
    label: {type: String, required: true},
  },
  computed: {
    isDone() {
      return !!this.task && this.task.progress && parseFloat(this.task.progress) === 1.0;
    },
    progress() {
      if (this.task) {
        const progress = this.task.progress && typeof (parseFloat(this.task.progress)) === 'number' ? parseFloat(this.task.progress) : 0;
        let finalProgress = (progress * 100.0).toFixed(1);
        if(finalProgress > 100) {
          finalProgress = 100;
        }
        return finalProgress;
      } else {
        return 0;
      }
    },
    duration() {
      if(this.task) {
        const {updatedAt, createdAt} = this.task;
        if(updatedAt && createdAt && updatedAt !== createdAt) {
          return timeDifferenceFromTwoISOsAsString(createdAt, updatedAt);
        }
      }
      return '';
    },
    totalItems() {
      return this.task ? this.task.totalItems : 0;
    }
  }
}
</script>

<style lang="scss" scoped>
.log-task {
  background-color: var(--vform-editor-ui-secondary-color);
  padding: 3px 6px;
  margin-bottom: 1px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.log-task-not-done {
  background-color: var(--vform-editor-ui-quinary-color);
}
.dz-progress {
  position: relative;
  width: 440px;
  padding: 0;
  height: 15px;
  margin-top: 2px;
  margin-bottom: -2px;

  .dz-upload {
    background-color: $highlight;
    height: 15px;

    p {
      position: absolute;
      left: 5px;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
    }
  }
}
</style>